
import Cloudkit from '../../images/cloudkit.svg'
import Defaultkit from '../../images/defaultkit.svg'
import Designkit from '../../images/designkit.svg'
import Marketkit from '../../images/marketkit.svg'
import Mobilkit from '../../images/mobilkit.svg'
import Testkit from '../../images/testkit.svg'
import Webkit from '../../images/webkit.svg'
import AIkit from '../../images/aikit.svg'
import Nineatoms from '../../images/nineatoms.svg'

import WebkitWrapper from '../../images/wrappers/webkit_wrapper.svg'
import DesignkitWrapper from '../../images/wrappers/designkit_wrapper.svg'
import MarketkitWrapper from '../../images/wrappers/marketkit_wrapper.svg'
import MobilkitWrapper from '../../images/wrappers/mobilkit_wrapper.svg'
import TestkitWrapper from '../../images/wrappers/testkit_wrapper.svg'
import CloudkitWrapper from '../../images/wrappers/cloudkit_wrapper.svg'
import AIkitWrapper from '../../images/wrappers/aikit_wrapper.svg'

export const colorPalette = {
    primary: '#FF4C00', //Alternative: #030092
}

export const wrappers = {
    'webkit': WebkitWrapper,
    'designkit': DesignkitWrapper,
    'marketkit': MarketkitWrapper,
    'mobilkit': MobilkitWrapper,
    'testkit': TestkitWrapper,
    'cloudkit': CloudkitWrapper,
    'aikit': AIkitWrapper,
}

export const images = {
    'cloudkit': Cloudkit,
    'defaultkit': Defaultkit,
    'designkit': Designkit,
    'marketkit': Marketkit,
    'mobilkit': Mobilkit,
    'testkit': Testkit,
    'webkit': Webkit,
    'aikit': AIkit,
    'nineatoms' : Nineatoms,
}


export const display_items = {
    tiles: [
        {id: '0'},
        {id: '1'},
        {id: '2'},
        {id: '3'},
        {id: '4'},
    ]
}

export const hero_section =
{
    id: 'nineatoms',
    wrapped: false,
    bg_color: '',
    img_first: false,
    title: [
        {
            id: '0',
            text: 'WE',
            color: '#fff',
            bg_color: '',
            font: 'ChakraPetch',
            font_size: '6vw',
            ls:'0.2vw',
        },
        {
            id: '1',
            text: 'PROVIDE',
            color: '#fff',
            bg_color: '',
            font: 'ChakraPetch',
            font_size: '6vw',
            ls: '1.2vw',
        },
        {
            id: '2',
            text: 'KITS',
            color: colorPalette['primary'],
            bg_color: '',
            font: 'ChakraPetch',
            font_size: '6vw',
            ls: '1.2vw',
        },
    ],
    description: {
        text: 'Conversion optimization, measuring, data and reporting solutions',
        color: '',
        bg_color: '',
        font: 'Michroma',
        font_size: '1.4vw',
    },
    button: {
        text: 'Contact',
        arrow: 'false',
        color: colorPalette['primary'],
        font: 'Michroma',
        font_size: '1.2vw',
        link: 'https://calendly.com/behramcelen/30min'
    }
}


export const sections = [
    {
        id: 'webkit',
        wrapped: true,
        bg_color: '',
        img_first: false,
        title: [
            {
                id: '0',
                text: 'WEB',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: false,
        }
    },
    {
        id: 'cloudkit',
        wrapped: true,
        bg_color: '',
        img_first: true,
        title: [
            {
                id: '0',
                text: 'CLOUD',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: true,
        }
    },
    {
        id: 'designkit',
        wrapped: true,
        bg_color: '',
        img_first: false,
        title: [
            {
                id: '0',
                text: 'DESIGN',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: false,
        }
    },
    {
        id: 'aikit',
        wrapped: true,
        bg_color: '',
        img_first: true,
        title: [
            {
                id: '0',
                text: 'AI',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: true,
        }
    },
    {
        id: 'testkit',
        wrapped: true,
        bg_color: '',
        img_first: false,
        title: [
            {
                id: '0',
                text: 'TEST',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: false,
        }
    },
    {
        id: 'marketkit',
        wrapped: true,
        bg_color: '',
        img_first: true,
        title: [
            {
                id: '0',
                text: 'MARKET',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: true,
        }
    },
    {
        id: 'mobilkit',
        wrapped: true,
        bg_color: '',
        img_first: false,
        title: [
            {
                id: '0',
                text: 'MOBIL',
                color: colorPalette['primary'],
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
            {
                id: '1',
                text: 'KIT',
                color: '',
                bg_color: '',
                font: 'Righteous',
                font_size: '5vw',
            },
        ],
        description: {
            text: 'Conversion optimization, measuring, data and reporting solutions',
            color: '',
            bg_color: '',
            font: 'Michroma',
            font_size: '1.6vw',
        },
        button: {
            text: 'See Details',
            arrow: 'true',
            color: colorPalette['primary'],
            font: 'Michroma',
            font_size: '1.1vw',
            img_first: false,
        }
    },
]


